/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccountsCheckinsListParams,
  Checkin,
  CheckinRequest,
  PaginatedCheckinList
} from '../types';

import { apiV2 } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Get a list of checkins with optional filtering
 * @summary List checkins
 */
export const accountsCheckinsList = (
    params?: AccountsCheckinsListParams,
 options?: SecondParameter<typeof apiV2<PaginatedCheckinList>>,) => {
      return apiV2<PaginatedCheckinList>(
      {url: `/accounts/checkins/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const accountsCheckinsCreate = (
    checkinRequest: CheckinRequest,
 options?: SecondParameter<typeof apiV2<Checkin>>,) => {
      return apiV2<Checkin>(
      {url: `/accounts/checkins/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkinRequest
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const accountsCheckinsRetrieve = (
    id: string,
 options?: SecondParameter<typeof apiV2<Checkin>>,) => {
      return apiV2<Checkin>(
      {url: `/accounts/checkins/${id}/`, method: 'GET'
    },
      options);
    }
  export type AccountsCheckinsListResult = NonNullable<Awaited<ReturnType<typeof accountsCheckinsList>>>
export type AccountsCheckinsCreateResult = NonNullable<Awaited<ReturnType<typeof accountsCheckinsCreate>>>
export type AccountsCheckinsRetrieveResult = NonNullable<Awaited<ReturnType<typeof accountsCheckinsRetrieve>>>
